interface FormatBytesOptions {
    units?: string[];
    space?: boolean;
    precision?: number;
    base?: number;
}

const DEFAULT_OPTIONS: Required<FormatBytesOptions> = {
    units:     ['bytes', 'KB', 'MB', 'GB', 'TB'],
    space:     true,
    precision: 2,
    base:      1024,
};

/**
 * Format bytes
 *
 * @param {Number} value
 * @param {Object} options
 *
 * @returns {String}
 */
export default function formatBytes(
    value: number,
    options: FormatBytesOptions = {},
): string {
    const { units, space, precision, base } = {
        ...DEFAULT_OPTIONS,
        ...options,
    };

    if (value === 0 || isNaN(value)) return `0${space ? ' ' : ''}${units[0]}`;

    const i = Math.floor(Math.log(value) / Math.log(base));

    const unitIndex = Math.min(i, units.length - 1);

    const size = value / base ** unitIndex;
    const formattedSize = size % 1 === 0 ? size.toString() : size.toFixed(precision);
    const separator = space ? ' ' : '';

    return `${formattedSize}${separator}${units[unitIndex]}`;
}
